import { render, staticRenderFns } from "./banner-dyn.vue?vue&type=template&id=0136297a&scoped=true&"
import script from "./banner-dyn.vue?vue&type=script&lang=js&"
export * from "./banner-dyn.vue?vue&type=script&lang=js&"
import style0 from "./banner-dyn.vue?vue&type=style&index=0&id=0136297a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136297a",
  null
  
)

export default component.exports